import React,{useEffect} from 'react'
import Index from './Pages/Index'


import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home/Home'
import Header from './Component/Header'
import Footer from './Component/Footer'

import AboutUs from './Pages/About/AboutUs'
import Courses from './Pages/Campus/Courses'
import Programs from './Pages/Program/Programs'
import Academics from './Pages/Campus/Academics'
import Admissions from './Pages/Campus/Admissions'
import Campus from './Pages/Campus/Campus'
import Archivements from './Pages/Campus/Archivements'
import ParentCorner from './Pages/Parentcorner/ParentCorner'
import EventDetail from './Pages/Eventdata/EventDetail'
import Contact from './Pages/Contact/Contact'
import Blog from './Pages/Blogs/Blog'
import InstituteBlogs from './Pages/Blogs/InstituteBlogs'
import BlogDetail from './Pages/Blogs/BlogDetail'




const App = () => {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById("mainNavbar");
      if (window.scrollY > 100) {
        navbar.classList.add("navbar-scrolled");
      } else {
        navbar.classList.remove("navbar-scrolled");
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    
      <BrowserRouter>
      <div className="site-wrapper">
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/AboutUs' element={<AboutUs />} />
          <Route path='/Courses' element={<Courses />} />
          <Route path='/Programs' element={<Programs />} />
          <Route path='/ContactUs' element={<Contact />} />
          <Route path='/Academics' element={<Academics />} />
          <Route path='/Admissions' element={<Admissions />} />
          <Route path='/Campus' element={<Campus />} />
          <Route path='/Archivements' element={<Archivements />} />
          <Route path='/Parentcorner' element={<ParentCorner />} />
          <Route path="/events/:id" element={<EventDetail />} />

          <Route path="/Blog" element={<Blog />} />
          <Route path='/Blog/:instituteId' element={<InstituteBlogs />} />
          <Route path='/Blog/:instituteId/:blogSlug' element={<BlogDetail />} />

        </Routes>
        <Footer />
      </div>
      </BrowserRouter>
     
   

  )
}

export default App
